export default __webpack_public_path__ + "static/media6-2e8ec42123a47c68bfd3d8887bbb4637.jpg";